import { Transaction } from '../transaction';

export class EvaluateServiceTransactionModalPayload {
  transaction: Transaction;
}
